import React, { useCallback } from 'react';
import { Tool, AssignmentLogEntry, Person, Warehouse, Users, ToolHistory, Classes } from '../../types';
import { ToolIcon, UserIcon, WarehouseIcon, LocationMarkerIcon, ArrowRightIcon } from './Icons';
import { wsurl } from '../../CommonFunctions';

interface ToolCardProps {
  tool: Tool;
  isSelected: boolean;
  onToggleSelect: (toolId: number) => void;
  assignmentDate?: number | null;
  assignee?: Users | null;
  warehouse?: Warehouse | null;
  history: ToolHistory[] | null;
  classes?: string|null;
}

const ToolCard: React.FC<ToolCardProps> = ({ tool, isSelected, onToggleSelect, assignmentDate, assignee, warehouse, history, classes }) => {
  
  const toolimageurl = () => {
    const imageUrl = wsurl + '/tools/image/' + tool.id;
    return imageUrl;
    //return "https://picsum.photos/id/200/200";
  };

  // format of -->tool.currentAssignmentLogId
  const isAssigned = ()=>{
    // is assigned and not released yet
    return  history!.filter((historyItem) => historyItem.toolid === tool.id).map((historyItem)=>{
      if(historyItem.released===null){
        return (historyItem.assigned!==null);
      } 
      return !(historyItem.released!>=historyItem.assigned);
    }).reduce((acc, curr)=>acc||curr,false);
  }
  const destination = () => {
     return  history!.find((historyItem) => historyItem.toolid === tool.id && historyItem.userid === assignee?.id)?.destination || '';
  }
  
  const handleSelect = () => {
    if (isAssigned()) return; // Don't allow selection if already assigned
    onToggleSelect(tool.id!);
  };
  return (
    <div className={`
      bg-slate-800 rounded-lg shadow-lg overflow-hidden transition-all duration-300 ease-in-out
      ${isAssigned() ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-slate-700/50 hover:scale-105'}
      ${isSelected && !isAssigned() ? 'ring-2 ring-sky-500 scale-105' : 'ring-1 ring-slate-700'}
    `}>
      <div className="relative">
        <img src={toolimageurl()} alt={tool.txt} className="w-full h-48 object-cover" />
        {!isAssigned() && (
           <input
            type="checkbox"
            checked={isSelected}
            onChange={handleSelect}
            aria-label={`Seleziona ${tool.txt}`}
            title={`Seleziona ${tool.txt}`}
            className="absolute top-3 right-3 h-6 w-6 rounded text-sky-500 bg-slate-700 border-slate-600 focus:ring-sky-500 cursor-pointer"
          />
        )}
         {isAssigned() && assignee && (
            <div className="absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full font-semibold">
              ASSEGNATO
            </div>
          )}
      </div>
      <div className="p-4">
        <h3 className="text-lg font-semibold text-sky-400 mb-1 truncate" title={tool.txt}>
          {tool.txt}
        </h3>
        <p className="text-sm text-slate-400 h-10 overflow-hidden text-ellipsis" title={tool.note}>
          {tool.note}
        </p>
        <span className="font-semibold"> {classes} </span>
        {isAssigned() && assignee ? (
          <div className="mt-3 pt-3 border-t border-slate-700 text-xs">
            <div className="flex items-center text-slate-300 mb-1">
              <UserIcon className="w-4 h-4 mr-2 text-amber-400" />
              <span>Assegnato a: <span className="font-semibold">{assignee.name}</span></span>
            </div>
            <div className="flex items-center text-slate-300">
              <LocationMarkerIcon className="w-4 h-4 mr-2 text-green-400" />
              <span>Destinazione: <span className="font-semibold">{destination()}</span></span>
            </div>
             <p className="text-slate-500 mt-1">Data: {new Date(assignmentDate!).toLocaleDateString()}</p>
          </div>
        ) : warehouse ? (
          <div className="mt-3 pt-3 border-t border-slate-700 text-xs">
            <div className="flex items-center text-slate-300">
              <WarehouseIcon className="w-4 h-4 mr-2 text-teal-400" />
              <span>Magazzino: <span className="font-semibold">{warehouse.name}</span></span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
/*<LocationMarkerIcon className="w-4 h-4 mr-2 text-emerald-400" />
              <span>Classe: <span className="font-semibold"> {classes} </span></span>
              */
export default ToolCard;